import React from "react";
import PropTypes from "prop-types";
import ColumnMatchTable from "./columnMatchTable";
import ColumnMatchResults from "./columnMatchResults";
// core imports
import { SFGridContainer, SFGridItem } from "../../../components/grid";
import getStyled from "../../../hooks/getStyled";

const { styled } = getStyled();

const StyledWrapper = styled("div")(({ theme }) => ({
  "& .MuiCard-root": {
    height: "100%",
  },
}));

const ColumnRow = ({
  mapping,
  colIndex,
  showWarning,
}) => {

  return (
    <StyledWrapper data-testid="col-row">
      <SFGridContainer sx={{ mb: 3 }} alignItems="stretch">
        <SFGridItem sm={12} md={6} lg={7} xl={8}>
          <ColumnMatchTable
            mapping={mapping}
            colIndex={colIndex}
            showWarning={showWarning}
          />
        </SFGridItem>
        <SFGridItem sm={12} md={6} lg={5} xl={4}>
          <ColumnMatchResults
            mapping={mapping}
          />
        </SFGridItem>
      </SFGridContainer>
    </StyledWrapper>
  );
};

ColumnRow.propTypes = {
  mapping: PropTypes.object.isRequired,
  colIndex: PropTypes.number.isRequired,
  showWarning: PropTypes.bool,
};

export default ColumnRow;
